import { call, select } from 'redux-saga/effects';
import { AudioPool } from 'utils/audio/AudioPool';
import { selectLocalMuteEnabled } from 'features/room/roomSlice';
import { selectLocallyMutedUserIds } from 'features/local-mute/localMuteSlice';
import { UserId } from 'features/users/types';

export function* applyLocalMuteSaga() {
  const enabled: boolean = yield select(selectLocalMuteEnabled);
  if (!enabled) {
    return;
  }

  const mutedUserIds: Record<UserId, true> = yield select(selectLocallyMutedUserIds);
  yield call(AudioPool.setLocallyMutedOwners, Object.keys(mutedUserIds));
}
